<template>
  <div class="all">
    <!-- 待支付账单 -->
    <div class="box-list">
      <noContent v-if="false" :explain="explain"></noContent>
      <!-- 搜索框 -->
      <div class="search">
        <el-input
          placeholder="输入对账单号"
          v-model="statementBillNo"
          class="input-with-select"
          size="small"
          clearable
          @clear="clearSearch"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleIconClick"
          ></el-button>
        </el-input>
      </div>
      <!-- 待未支付 -->
      <div v-if="isShow1">
        <!-- 批量操作按钮 -->
        <div class="bulk-operation-box df" v-if="NotPayingBills.length > 0">
          <div class="headline">
            <signboard signboardName="待支付账单"></signboard>
          </div>
          <div v-if="isShow2">
            <div v-if="!bulkOperation" class="bulk-operation">
              <el-button type="text" @click="bulkOperations"
                >批量操作
              </el-button>
            </div>
            <div v-else class="bulk-operation df">
              <el-button type="text" @click="bulkOperations"
                >取消批量操作
              </el-button>
              <div class="cut-off-rule" v-if="!showBatchConfirmationBill"></div>
              <el-button
                type="text"
                @click="BatchConfirmationStatement()"
                v-if="!showBatchConfirmationBill"
                >批量确认账单
              </el-button>
              <div class="cut-off-rule"></div>
              <div class="fr df" v-if="!showBatchConfirmationBill">
                <div class="money">支付金额：<span>￥</span></div>
                <div class="df">
                  <div class="money-input" v-if="!isDisabled">
                    <el-input
                      size="small"
                      placeholder="0.00"
                      v-model="money"
                      disabled
                    ></el-input>
                  </div>
                  <div class="money-input" v-else>
                    <el-input
                      size="small"
                      placeholder="0.00"
                      v-model="money"
                    ></el-input>
                  </div>
                  <div>
                    <el-button
                      type="primary"
                      size="small"
                      @click="selectPayment"
                      >支付已选金额
                    </el-button>
                  </div>
                </div>
              </div>
              <div class="fr df" v-if="showBatchConfirmationBill">
                <div class="money money-input">
                  已选账单数：{{ BillSelectedQuantity }}
                </div>
                <div class="df">
                  <div>
                    <el-button
                      type="primary"
                      size="small"
                      @click="BatchConfirmationBill"
                      >确认已选账单
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 待支付列表 -->
        <!-- 批量支付列表 -->
        <div v-if="!showBatchConfirmationBill" class="df unpaid-list">
          <div
            class="item"
            v-for="(item, key) in NotPayingBills"
            :key="item.value"
            :class="item.check ? 'bgc' : ''"
          >
            <div
              :class="[
                item.status == 'un_confirm' && bulkOperation
                  ? 'title-img'
                  : 'title',
                'df',
              ]"
            >
              <div class="df w50">
                <div
                  class="checkbox"
                  v-if="bulkOperation"
                  @change.stop="checked(item, key)"
                >
                  <el-checkbox
                    :value="item.check"
                    v-if="item.status == 'confirm'"
                  ></el-checkbox>
                </div>
                <div
                  class="gray-word text-hidden pointer"
                  :title="item.statBillNo"
                  @click="out(item)"
                >
                  {{ item.statBillNo }}
                </div>
              </div>
              <div class="text-align-right w50 text-hidden">
                <span class="gray-word">待支付：</span>
                <span class="bgc-blue">{{ item.unRefundAmount }}元</span>
              </div>
            </div>
            <div class="list gray-word" @click="out(item)">
              <div
                class="row df pointer text-hidden"
                title="上海嘉定区浦江镇营业部"
              >
                <div>营业部：</div>
                <div>{{ item.actionOrgName }}</div>
              </div>
              <div class="row df text-hidden">
                <div>账期：</div>
                <div>
                  {{
                    item.billStar
                      ? $moment(item.billStar).format("YYYY-MM-DD") +
                        "&nbsp;&nbsp;至&nbsp;&nbsp;"
                      : ""
                  }}{{ $moment(item.billEnd).format("YYYY-MM-DD") }}
                </div>
              </div>
            </div>
            <div class="df btn">
              <div class="df" v-if="!bulkOperation">
                <!-- 支付账单按钮 -->
                <el-popover
                  placement="bottom-start"
                  width="500"
                  trigger="click"
                  v-model="item.confirmPayment"
                >
                  <div>
                    <h4 style="color: #000">确认账单，并支付<span style="color:red;margin-left: 30px;font-size: 12px;">温馨提示：请勿转账给个人！</span></h4>
                    <div class="gray-word" style="margin: 10px 0">
                      支付后，即默认您已确认账单无异常
                    </div>
                    <div class="df">
                      <div class="money" style="line-height: 32px">
                        支付金额：<span>￥</span>
                      </div>
                      <div style="width: 100px; margin: 0px 15px 0 5px">
                        <el-input
                          size="small"
                          placeholder="0.00"
                          v-model="money"
                        ></el-input>
                      </div>
                      <el-button
                        type="primary"
                        size="small"
                        slot="reference"
                        @click="singlePayment(item)"
                        >确认支付
                      </el-button>
                      <el-button
                        size="small"
                        slot="reference"
                        @click="showBankAccount(item.statBillNo)"
                        >电汇转账
                      </el-button>
                      <el-button
                        size="small"
                        slot="reference"
                        @click="item.confirmPayment = false"
                        >暂不支付
                      </el-button>
                    </div>
                  </div>
                  <el-button
                    type="primary"
                    size="small"
                    slot="reference"
                    @click="pay(item)"
                    >支付账单
                  </el-button>
                </el-popover>
                <!-- 确认账单按钮 -->
                <el-popover
                  v-if="item.status == 'un_confirm'"
                  placement="bottom"
                  width="300"
                  trigger="click"
                  v-model="item.ConfirmTheBill"
                >
                  <div>
                    <h4 style="color: #000">确认账单提醒</h4>
                    <div class="gray-word" style="margin: 10px 0">
                      您是否要确认对账账单？确认后不可更改。
                    </div>
                    <div style="text-align: right; margin: 0">
                      <el-button
                        size="small"
                        slot="reference"
                        @click="item.ConfirmTheBill = false"
                        >暂不确认
                      </el-button>
                      <el-button
                        type="primary"
                        size="small"
                        slot="reference"
                        @click="confirmPay(item)"
                        >确认对账单
                      </el-button>
                    </div>
                  </div>
                  <el-button
                    class="padding-left"
                    type="text"
                    slot="reference"
                    size="small"
                    >确认账单
                  </el-button>
                </el-popover>
                <el-button
                  class="padding-left"
                  size="small"
                  type="text"
                  v-else
                  disabled
                  >确认对账单
                </el-button>
                <div class="cut-off-rule"></div>
                <!-- 获取账单 -->
                <el-popover
                  placement="bottom"
                  trigger="click"
                  v-model="item.ToGetTheBill"
                >
                  <div
                    class="pointer"
                    style="text-align: center; color: #000; line-height: 28px"
                  >
                    <div
                      style="margin-bottom: 10px; color: #00000085"
                      @click="ToGetTheBill(item, key, '下载账单')"
                    >
                      下载账单
                    </div>
                     <div
                      style="margin-bottom: 10px; color: #00000085"
                      @click="ToGetTheBill(item, key, '异步下载账单')"
                    >
                      异步下载账单
                    </div>
                    <!-- <div @click="item.ToGetTheBill2 = false">打印账单</div> -->
                    <div
                      style="color: #00000085"
                      @click="ToGetTheBill(item, key, '发送邮箱')"
                    >
                      发送邮箱
                    </div>
                  </div>
                  <el-button type="text" slot="reference" size="small"
                    >获取账单<i class="el-icon-arrow-down"></i
                  ></el-button>
                </el-popover>
              </div>
              <div v-else>
                <div v-if="item.status == 'un_confirm'">
                  该账单未确认，不能支付
                </div>
                <div v-if="item.status == 'confirm'">
                  <el-button
                    v-if="!item.check"
                    type="text"
                    size="small"
                    @click="checked(item, key)"
                    >选择账单
                  </el-button>
                  <el-button
                    v-if="item.check"
                    type="text"
                    size="small"
                    @click="checked(item, key)"
                    >取消账单
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 批量确认列表 -->
        <div v-else class="df unpaid-list">
          <div
            class="item"
            v-for="(item, key) in NotPayingBills"
            :key="item.value"
            :class="item.check ? 'bgc' : ''"
          >
            <div
              :class="[
                item.status == 'confirm' && bulkOperation
                  ? 'title-img'
                  : 'title',
                'df',
              ]"
            >
              <div class="df w50">
                <div
                  class="checkbox"
                  v-if="bulkOperation"
                  @change.stop="checked(item, key)"
                >
                  <el-checkbox
                    :value="item.check"
                    v-if="item.status == 'un_confirm'"
                  ></el-checkbox>
                </div>
                <div
                  class="gray-word text-hidden pointer"
                  :title="item.statBillNo"
                  @click="out(item)"
                >
                  {{ item.statBillNo }}
                </div>
              </div>
              <div class="text-align-right w50 text-hidden">
                <span class="gray-word">待支付：</span>
                <span class="bgc-blue">{{ item.unRefundAmount }}元</span>
              </div>
            </div>
            <div class="list gray-word" @click="out(item)">
              <div
                class="row df pointer text-hidden"
                title="上海嘉定区浦江镇营业部"
              >
                <div>营业部：</div>
                <div>{{ item.actionOrgName }}</div>
              </div>
              <div class="row df text-hidden">
                <div>账期：</div>
                <div>
                  {{
                    item.billStar
                      ? $moment(item.billStar).format("YYYY-MM-DD") +
                        "&nbsp;&nbsp;至&nbsp;&nbsp;"
                      : ""
                  }}{{ $moment(item.billEnd).format("YYYY-MM-DD") }}
                </div>
              </div>
            </div>
            <div class="df btn">
              <div>
                <div v-if="item.status == 'confirm'">
                  该账单已确认，不能重复确认
                </div>
                <div v-if="item.status == 'un_confirm'">
                  <el-button
                    v-if="!item.check"
                    type="text"
                    size="small"
                    @click="checked(item, key)"
                    >选择账单
                  </el-button>
                  <el-button
                    v-if="item.check"
                    type="text"
                    size="small"
                    @click="checked(item, key)"
                    >取消账单
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页  v-if="unpaidInfo.length > 12" -->
        <div class="bottom">
          <el-pagination
            v-if="totalNumber1 > 8"
            background
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="currpage1"
            :page-sizes="[8, 16, 32]"
            :page-size="pagesize1"
            layout="total,prev, pager, next, sizes,jumper"
            :total="totalNumber1"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 已支付账单 -->
    <div class="box-list" v-if="isShow2">
      <signboard v-if="paidList" signboardName="已支付账单"></signboard>
      <!-- 时间段选择 -->
      <div v-if="paidList" class="time-quantum">
        <el-select
          v-model="timeQuantum"
          placeholder="最近3个月"
          size="small"
          @change="TimeRangeSearch"
        >
          <el-option
            v-for="item in options"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 已支付列表 -->
      <div class="df unpaid-list" v-if="ISnoData">
        <div class="item" v-for="item in PaidBill" :key="item.value">
          <div class="title title-img df">
            <div class="df w50" :title="item.statBillNo" @click="out(item)">
              <div class="gray-word text-hidden pointer">
                {{ item.statBillNo }}
              </div>
            </div>
            <div class="text-align-right w50 text-hidden">
              <span class="gray-word">总金额：</span>
              <span class="gray-word">{{ item.totalAmount }}元</span>
            </div>
          </div>
          <div class="list gray-word" @click="out(item)">
            <div class="row df pointer" title="上海嘉定区浦江镇营业部">
              <div>营业部：</div>
              <div>{{ item.actionOrgName }}</div>
            </div>
            <div class="row df">
              <div>账期：</div>
              <div>
                {{
                  item.billStar
                    ? $moment(item.billStar).format("YYYY-MM-DD") +
                      "&nbsp;&nbsp;至&nbsp;&nbsp;"
                    : ""
                }}{{ $moment(item.billEnd).format("YYYY-MM-DD") }}
                <!-- {{
                                  $moment(item.billStar).format("YYYY-MM-DD")
                                  }}&nbsp;&nbsp;至&nbsp;&nbsp;{{
                                  $moment(item.billEnd).format("YYYY-MM-DD")
                                  }} -->
              </div>
            </div>
          </div>
          <div class="btn df">
            <!-- 获取账单 -->
            <el-popover
              placement="bottom"
              trigger="click"
              v-model="item.ToGetTheBill"
            >
              <div
                class="pointer"
                style="text-align: center; color: #000; line-height: 28px"
              >
                <div style="margin-bottom: 10px; color: #00000085" @click="ToGetTheBill(item, key, '下载账单')">下载账单</div>
                <!-- <div @click="item.ToGetTheBill2 = false">打印账单</div> -->
                <div
                    style="margin-bottom: 10px; color: #00000085"
                    @click="ToGetTheBill(item, key, '异步下载账单')"
                  >
                    异步下载账单
                  </div>
                <div style="color: #00000085"  @click="ToGetTheBill(item, key, '发送邮箱')">发送邮箱</div>
              </div>
              <el-button type="text" slot="reference" size="small"
                >获取账单<i class="el-icon-arrow-down"></i
              ></el-button>
            </el-popover>
          </div>
          <div class="closed-account-img">
            <img
              class="Open-according-to"
              src="../../../assets/picture/closed-account.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- 已支付分页 v-if="havePaidInfo.length > 12" -->
      <div class="bottom" v-if="ISnoData">
        <el-pagination
          v-if="totalNumber2 > 8"
          background
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="currpage2"
          :page-sizes="[8, 16, 32]"
          :page-size="pagesize2"
          layout="total,prev, pager, next, sizes,jumper"
          :total="totalNumber2"
        >
        </el-pagination>
      </div>
      <!-- 没有数据展示 -->
      <div class="no-data" v-if="!ISnoData">
        <noContent
          style="margin-top: 80px"
          explain="没有搜到相关对账单"
        ></noContent>
      </div>
    </div>
    <!-- 下载账单弹框 -->
    <el-dialog
      class="fl"
      title="请选择下载账单格式"
      :visible.sync="NewDialogBox1"
      width="34%"
      top="236px"
    >
      <div class="strong-frame">
        <div class="row">
          <div
            :class="DownloadTheformat == 'excel' ? 'divpitch-on' : ''"
            @click="DownloadTheformat = 'excel'"
          >
            <img class="excel" src="../../../assets/picture/excel.png" alt="" />
          </div>
          <div
            :class="DownloadTheformat == 'pdf' ? 'divpitch-on' : ''"
            @click="DownloadTheformat = 'pdf'"
          >
            <img class="pdf" src="../../../assets/picture/pdf.png" alt="" />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="NewDialogBox1 = false" size="small">取 消</el-button>
        <el-button
          @click="download"
          type="primary"
          size="small"
          :loading="downloadLoading"
          >下载</el-button
        >
      </span>
    </el-dialog>
    <!-- 账单发送邮箱 -->
    <el-dialog
      class="fl"
      title="发送邮箱"
      :visible.sync="NewDialogBox2"
      width="34%"
      top="236px"
    >
      <div
        v-for="(emailItem, index) in emailList"
        :key="index"
      >
        <div class="strong-frame top df">
          <span style="width: 80px; line-height: 32px">邮箱{{ index + 1 }}：</span>
          <el-input
            v-model="emailItem.value"
            :placeholder="`请输入邮箱${index + 1}`"
            size="small"
          ></el-input>
          <i
            v-if="index > 0"
            class="el-icon-delete"
            style="margin-left: 8px; line-height: 32px; cursor: pointer; color: #f56c6c;"
            @click="emailList.splice(index, 1)"
          ></i>
        </div>
        <div
          v-if="emailItem.error"
          style="color: #f56c6c; font-size: 12px; padding-left: 80px; "
        >邮箱格式不正确</div>
      </div>
      <div style="margin-top: 8px">
        <el-button
          v-if="emailList.length < 3"
          type="text"
          icon="el-icon-plus"
          size="small"
          @click="addEmail"
        >新增邮箱</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="NewDialogBox2 = false" size="small">取 消</el-button>
        <el-button @click="SendEmail" type="primary" size="small"
          >发 送</el-button
        >
      </span>
    </el-dialog>
    <!-- 批量确认账单弹框 -->
    <el-dialog
      class="fl"
      title="温馨提示"
      :visible.sync="NewDialogBox3"
      width="34%"
      top="236px"
    >
      <div class="strong-frame top df">{{ ConfirmBillPrompt }}</div>
      <div slot="footer" style="text-align: center">
        <el-button @click="NewDialogBox3 = false" size="small">{{
          whetherTick ? "取消确认" : "去勾选"
        }}</el-button>
        <el-button
          v-if="whetherTick"
          @click="BillConfirmation"
          style="margin-left: 100px"
          type="primary"
          size="small"
          >确认账单</el-button
        >
      </div>
    </el-dialog>

    <!-- 银行账号复制 -->
    <el-dialog
      title="电汇账号信息"
      :visible.sync="isShowAccountDialog"
      width="450px">
      <div class="e_account">
        <div><label for="">开户名：</label>{{formAccount.compBankAccountName}}</div>
        <div><label for="">开户行：</label>{{formAccount.compBankName}}</div>
        <div><label for="">开户账号：</label>{{formAccount.compBank}}</div>
        <h5 style="margin-top:8px;color:red; font-size:12px;">温馨提示：请勿转账给个人！</h5>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowAccountDialog = false" size="small">关 闭</el-button>
        <el-button type="primary" @click="copyAccountInfo" size="small">一键复制</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import signboard from "@/components/signboard";
import noContent from "@/components/noContent";
import API from "../../../api/bill";
import axios from "axios";
const api = new API();
export default {
  components: { noContent, signboard },
  data() {
    return {
      whetherTick: false,
      ConfirmBillPrompt: "",
      batchStatBillNos: [],
      BillSelectedQuantity: 0,
      showBatchConfirmationBill: false,
      timeId: null,
      downloadLoading: false,
      emailList: [{ value: "", error: false }],
      mailbox: "",
      gitBill: "",
      DownloadTheformat: "excel",
      NewDialogBox3: false,
      NewDialogBox1: false,
      NewDialogBox2: false,
      ISnoData: true,
      isShow1: true,
      isShow2: true,
      statementBillNo: "",
      paidList: true,
      totalNumber1: 0,
      pagesize1: 8, //每页的数据条数
      currpage1: 1, //默认开始页面
      currpage2: 1, //默认开始页面
      pagesize2: 8, //每页的数据条数
      totalNumber2: 0, //已支付总条数
      //   ToGetTheBill2: false,
      //   ToGetTheBill: false,
      // check: false,
      bulkOperation: false,
      money: "",
      state: "",
      explain: "没有搜到相关对账单",
      timeQuantum: "最近3个月",
      timeRange: "3",
      isDisabled: false,
      checkArray: [],
      options: [
        { value: "3", label: "最近3个月" },
        { value: "6", label: "最近半年" },
        { value: "12", label: "最近1年" },
      ],
      NotPayingBills: [],
      PaidBill: [],
      isShowAccountDialog:false,
      formAccount:{}
    };
  },
  methods: {
    // 批量确认账单按钮
    BatchConfirmationStatement() {
      this.BillSelectedQuantity = 0;
      this.showBatchConfirmationBill = true;
      this.NotPayingBills.forEach((item) => {
        if (item.check) {
          item.check = false;
        }
      });
    },
    async confirmPay(item) {
      item.ConfirmTheBill = false;
      // 请求确认对账单接口
      api.confirmBillList([item.statBillNo]).then((res) => {
        item.status = "confirm";
        console.log(res);
      });
    },
    // 批量确认账单
    BatchConfirmationBill() {
      this.NewDialogBox3 = true;
      this.batchStatBillNos = [];
      this.NotPayingBills.forEach((item) => {
        if (item.check) {
          this.batchStatBillNos.push(item.statBillNo);
        }
      });
      console.log(this.batchStatBillNos, "this.batchStatBillNos");
      if (this.batchStatBillNos.length == 0) {
        this.ConfirmBillPrompt = "请勾选对账单";
        this.whetherTick = false;
      } else {
        this.whetherTick = true;
        this.ConfirmBillPrompt = "未确认账单：" + this.batchStatBillNos;
      }
      //   this.confirmPay()
    },
    // 批量确认账单 确认按钮
    BillConfirmation() {
      this.NewDialogBox3 = false;
      api.confirmBillList(this.batchStatBillNos).then((res) => {
        this.$message({
          message: "确认成功",
          type: "success",
        });
        setInterval(() => {
          location.reload();
        }, 2000);

        console.log(res);
      });
    },
    // 获取邮箱
    async getCustomerEmail() {
      let res = await api.getCustomerEmail();
      if (res) {
        this.emailList = [{ value: res[0] || "", error: false }];
        this.mailbox = res[0] || "";
      }
    },
    // 新增邮箱输入行
    addEmail() {
      if (this.emailList.length < 3) {
        this.emailList.push({ value: "", error: false });
      }
    },
    // 发送邮箱
    SendEmail() {
      var reg =
        /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
      let hasError = false;
      const validEmails = [];
      this.emailList.forEach((emailItem) => {
        const email = (emailItem.value || "").trim();
        if (email) {
          if (reg.test(email)) {
            emailItem.error = false;
            validEmails.push(email);
          } else {
            emailItem.error = true;
            hasError = true;
          }
        } else {
          emailItem.error = false;
        }
      });
      if (hasError || validEmails.length === 0) {
        return;
      }
      this.mailbox = validEmails.join(",");
      this.$emit("acquireEmail", this.mailbox);
      this.sendEmailExcel();
    },
    async sendEmailExcel() {
      let parme = {
        statBillNo: this.gitBill,
        email: this.mailbox,
      };
      let res = await api.sendEmailExcel(parme);
      if (res) {
        if (res == "发送成功！") {
          this.NewDialogBox2 = false;
          console.log(res);
          this.$message({
            message: res,
            type: "success",
          });
        }
      }
    },
    // 下载
    download() {
      this.downloadLoading = true;
      api
        .startDownload({
          statBillNo: this.gitBill,
          downLoadType: this.DownloadTheformat,
        })
        .then((resp) => {
          let downloadKey = resp;
          console.info(downloadKey);
          window.sessionStorage.setItem("downloadKey", downloadKey);
          this.timeId = window.setTimeout(() => {
            //应用setInterval来刷新getList()
            this.tryDownLoad();
          }, 1000);
        });
    },
    tryDownLoad() {
      let downloadKey = window.sessionStorage.getItem("downloadKey");
      let preParam = {
        statBillNo: this.gitBill,
        downLoadType: this.DownloadTheformat,
        downloadStatus: "query",
        downloadKey: downloadKey,
      };
      axios
        .post("statements/downloadFile", preParam)
        .then((res) => {
          if ("success" == res.data) {
            this.downloadFinal();
          } else {
            console.info("downloading");
          }
          if ("downloading" == res.data) {
            window.setTimeout(() => {
              this.tryDownLoad();
            }, 2000);
          }
        })
        .catch(function (error) {
          console.info(error);
        });
    },
    async downloadFinal() {
      // let list_name = "账单";
      let downloadKey = window.sessionStorage.getItem("downloadKey");
      let param = {
        statBillNo: this.gitBill,
        downLoadType: this.DownloadTheformat,
        downloadStatus: "download",
        downloadKey: downloadKey,
      };
      let res = await api.downloadFile2(param);
      this.downloadLoading = false;
      this.NewDialogBox1 = false;
      this.$message({
        message: "下载成功",
        type: "success",
      });
      // debugger
      let link = document.createElement("a");
      //    type就是blob的type,是MIME类型的，可以自己查看MIME类型都有哪些
      let blogw = new Blob([res.data], {
        type: "application/vnd.ms-excel;charset=utf-8",
      });
      let objectUrl = window.URL.createObjectURL(blogw); //创建一个新的url对象
      link.href = objectUrl;
      link.download = decodeURI(
        escape(
          res.headers["content-disposition"].replace("attachment;filename=", "")
        )
      ); //  下载的时候的文件名
      link.click();
      window.URL.revokeObjectURL(objectUrl); //为了更好地性能和内存使用状况，应该在适当的时候释放url.
      window.clearInterval(this.timeId);
      this.timeId = null;
    },
    // 获取账单
    ToGetTheBill(item, key, distinction) {
      this.gitBill = item.statBillNo;
      console.log(this.gitBill);
      debugger
      if (distinction == "下载账单") {
        // console.log('下载账单');
        this.NewDialogBox1 = true;
      } else if(distinction == "异步下载账单"){
        let formData = {
          "customerCode":window.localStorage.getItem("customerCode"),
          "statementNo":item.statBillNo 
        }
        api.launchPCStatBillFile(formData).then((res) => {
          if(res.success && res.data){
            item.ToGetTheBill = false;
              this.$message({
              message:res.data,
              type: "success",
            });
          }
        });
      } else {
        this.EmailError = false;
        this.NewDialogBox2 = true;
        this.getCustomerEmail();
        //  console.log('发送邮箱');
      }
      console.log(item, key, distinction);
    },
    async NotPayingBillsRequest() {
      let parme = {
        currentPage: this.currpage1,
        pageSize: this.pagesize1,
        isPaid: "N", //是否已支付
      };
      let res = await api.queryAllBillStatement(parme);
      console.log(res);
      if (res) {
        this.NotPayingBills = res.datalist;
        this.totalNumber1 = res.total;
        this.NotPayingBills.forEach((item) => {
          item.check = false;
        });
      }
    },
    async PaidBillRequest() {
      let parme = {
        timeRange: this.timeRange,
        currentPage: this.currpage2,
        pageSize: this.pagesize2,
        isPaid: "Y", //是否已支付
      };
      let res = await api.queryAllBillStatement(parme);
      if (res) {
        this.ISnoData = true;

        this.PaidBill = res.datalist;
        this.totalNumber2 = res.total;
        console.log(res);
      } else {
        this.ISnoData = false;
      }
    },
    async searchRequest() {
      let parme = {
        statementBillNo: this.statementBillNo,
      };
      let res = await api.queryAllBillStatement(parme);

      if (res.datalist.length != 0) {
        this.paidList = true;
        if (res.datalist[0].settledStatus == "un_completion") {
          this.NotPayingBills = res.datalist;
          this.totalNumber1 = 0;
          this.isShow2 = false;
        } else {
          this.PaidBill = res.datalist;
          this.totalNumber2 = 0;
          this.isShow1 = false;
        }
      } else {
        this.PaidBill = [];
        this.NotPayingBills = [];
        this.totalNumber1 = 0;
        this.totalNumber2 = 0;
        this.isShow2 = true;
        this.paidList = false;
        this.ISnoData = false;
      }
    },
    // 批量操作
    bulkOperations() {
      this.showBatchConfirmationBill = false;
      this.money = 0;
      this.bulkOperation = !this.bulkOperation;
      if (!this.bulkOperation) {
        this.NotPayingBills.forEach((item) => {
          item.check = false;
        });
      }
    },
    handleIconClick() {
      //搜索
      console.log("搜索");
      if (this.statementBillNo.replace(/\s*/g, "") == "") {
        this.isShow2 = true;
        this.isShow1 = true;
        this.paidList = true;
        this.NotPayingBillsRequest(); // 待支付请求
        this.PaidBillRequest(); // 已支付请求
        return;
      }
      this.searchRequest();
    },
    // 已支付账单按照时间段搜索
    TimeRangeSearch(value) {
      console.log(value);
      this.currpage2 = 1;
      this.timeRange = value;
      this.PaidBillRequest();
    },
    clearSearch() {
      this.isShow2 = true;
      this.isShow1 = true;
      this.paidList = true;
      this.NotPayingBillsRequest(); // 待支付请求
      this.PaidBillRequest(); // 已支付请求
    },
    out(item) {
      //去详情页
      console.log(item, "this.item");
      window.sessionStorage.setItem("detailBill", JSON.stringify(item));
      window.localStorage.setItem("detailBill", JSON.stringify(item));
      this.$router.push({ path: "/bill/detailBill" });
    },
    // 待支付账单 分页 : 选择展示条数
    handleSizeChange1(val) {
      this.pagesize1 = val;
      this.currpage1 = 1; // 切换 没有多少条的时候 重置为第1页开始
      this.NotPayingBillsRequest();
      this.BillSelectedQuantity = 0;
    },
    // 待支付账单 :分页 : 换页
    handleCurrentChange1(val) {
      this.currpage1 = val;
      this.NotPayingBillsRequest();
      this.BillSelectedQuantity = 0;
    },
    //已支付账单 分页 : 选择展示条数
    handleSizeChange2(val) {
      this.pagesize2 = val;
      this.currpage2 = 1;
      this.PaidBillRequest();
    },
    // 已支付账单 分页 : 换页
    handleCurrentChange2(val) {
      this.currpage2 = val;
      this.PaidBillRequest();
    },
    // 加减金额计算
    AmountOfCalculation() {
      //   console.log('计算金额');
      this.money = 0;
      this.checkArray = [];
      this.NotPayingBills.forEach((item) => {
        if (item.check) {
          this.checkArray.push(item);
          this.money += item.unRefundAmount;
        }
      });
    },
    //未支付勾选框
    checked(item, key) {
      // console.log('勾选',item,this.NotPayingBills[key].check);
      if (this.showBatchConfirmationBill == true) {
        this.NotPayingBills[key].check = !item.check;
        let aa = this.NotPayingBills;
        this.NotPayingBills = [];
        this.NotPayingBills = aa;
        this.BillSelectedQuantity = 0;
        this.NotPayingBills.forEach((item) => {
          if (item.check) {
            this.BillSelectedQuantity++;
          }
        });
        console.log("勾选", item, this.NotPayingBills[key].check);
        return;
      }
      if (item.unRefundAmount < 0) {
        this.$message({
          showClose: true,
          message: "账单应收未负值，无需支付，请联系对账会计处理！",
          type: "error",
          offset: 300,
        });
      }
      this.NotPayingBills[key].check = !item.check;
      this.isDisabled = true;
      if (item.check) {
        this.AmountOfCalculation();
        this.ToInvoice = true;
        this.mayMake = true;
      } else {
        this.AmountOfCalculation();
        if (this.checkArray.length == false) {
          this.isDisabled = false;
          return;
        }
      }
    },
    pay(item) {
      this.money = item.unRefundAmount;
    },
    // 单个支付，手动确认
    singlePayment(item) {
      if (this.money > item.unRefundAmount) {
        this.money = item.unRefundAmount;
        return this.$message({
          showClose: true,
          message: "支付金额不能大于账单金额",
          type: "error",
          offset: 300,
        });
      }
      if (this.money <= 0) {
        this.money = item.unRefundAmount;
        return this.$message({
          showClose: true,
          message: "输入金额不能小于或等于0",
          type: "error",
          offset: 300,
        });
      }
      var reg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/;
      if (!reg.test(this.money)) {
        this.money = item.unRefundAmount;
        return this.$message({
          showClose: true,
          message: "请输入保留两位小数点的正数",
          type: "error",
          offset: 300,
        });
      }
      item.confirmPayment = false;
      // 调用支付
      this.payment([item.statBillNo], this.money);
    },
    // 全量支付
    allPayment() {
      this.confirmPayment = false;
      api.createTotalPayOrder("" + this.money).then((res) => {
        console.log(res.data);
        window.open(res.data);
      });
    },
    // 选中支付
    selectPayment() {
      if (this.checkArray.length == false) {
        this.$message({
          showClose: true,
          message: "请先勾选账单再进行操作",
          type: "error",
          offset: 300,
        });
        return;
      }
      if (this.money <= 0) {
        console.log(222222222);
        this.AmountOfCalculation();
        return this.$message({
          showClose: true,
          message: "输入金额不能小于或等于0",
          type: "error",
          offset: 300,
        });
      }
      var reg = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/;
      if (!reg.test(this.money)) {
        this.AmountOfCalculation();
        return this.$message({
          showClose: true,
          message: "请输入保留两位小数点的正数",
          type: "error",
          offset: 300,
        });
      }
      //    console.log("支付账单");
      let statBillNos = [];
      var totalMoney = 0;
      this.checkArray.forEach((item) => {
        // 判断是否选中了未确认的账单
        if (item.status == "un_confirm") {
          this.$message({
            showClose: true,
            message: "请先确认账单：" + item.statBillNo + " !",
            type: "error",
            offset: 300,
          });
          return;
        }
        // 累加金额
        totalMoney = totalMoney + item.unRefundAmount;
        statBillNos.push(item.statBillNo);
      });

      if (totalMoney < this.money) {
        this.AmountOfCalculation();
        this.$message({
          showClose: true,
          message: "手填金额大于账单最大总和！",
          type: "error",
          offset: 300,
        });
        return;
      }

      if (this.money <= 0) {
        this.AmountOfCalculation();
        this.$message({
          showClose: true,
          message: "支付金额应大于 0 元！",
          type: "error",
          offset: 300,
        });
        return;
      }
      console.log(statBillNos, this.money);
      // 调用支付
      this.payment(statBillNos, this.money);
    },

    // 批量支付，自动确认
    payment(statBillNos, money) {
      debugger
      //支付
      api.createPmcPaymentOrder("" + money, statBillNos).then((payRes) => {
        if(payRes.success){
          window.open(payRes.cashierUrl);
          return;
        }
        this.$message({
          message:payRes,
          type: "error",
          offset: 300,
        });
      });
      // api.createPayOrder("" + money, statBillNos).then((payRes) => {
      //   console.log("支付url: ", payRes);
      //   window.open(payRes);
      // });
    },
    copy(data) {
      // 点击复制运单号
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$message({
        message: "复制成功",
        type: "success",
      });
      oInput.remove();
    },
     //显示账号信息
     async showBankAccount(statBillNo){
      let formData = {
        statementBillNo:statBillNo,
        customerCode: window.localStorage.getItem("customerCode"),
      }
      let res = await api.queryBankInfoByStatNoOrCustomerCode(formData)
      if(res instanceof Object){
        this.confirmPayment = false;
        this.isShowAccountDialog = true
        this.formAccount = res;
      }
    },
    //复制银行账号
    copyAccountInfo(){
     // 点击复制运单号
      let { compBankAccountName, compBankName, compBank } = this.formAccount;
      let str = `${compBankAccountName}-${compBankName}-${compBank}`;
      let oInput = document.createElement("input");
      oInput.value = str;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$message({
        message: "账号复制成功,请到银联app转账！请勿转账给个人",
        type: "success",
      });
      oInput.remove();
      this.isShowAccountDialog = false;
    }
  },
  created() {
    this.NotPayingBillsRequest(); // 待支付请求
    this.PaidBillRequest(); // 已支付请求
  },
};
</script>
  <style lang='less' scoped>
.all {
  width: 100%;
  height: 100%;
  font-size: 14px;

  .Email-error {
    font-size: 13px;
    color: #f56c6c;
    text-align: left;
    padding-left: 70px;
    margin-top: 5px;
  }

  .top {
    margin-top:5px;
  }
  .strong-frame {
    .row {
      display: flex;
      div {
        width: 68px;
        height: 68px;
        background: #f2f2f2;
        margin-right: 32px;
      }
      .divpitch-on {
        background: #d4ebff;
        border-radius: 3px;
        border: 1px solid #008cff;
      }
      .excel {
        margin-top: 16px;
        width: 40px;
        height: 36px;
      }
      .pdf {
        margin-top: 13px;
        width: 35px;
        height: 42px;
      }
    }
  }
  .text-align-right {
    text-align: right;
  }

  .bgc {
    border: 1px solid #008cff;
  }

  .search {
    width: 328px;
    text-align: left;
  }

  .bulk-operation-box {
    justify-content: space-between;
    line-height: 60px;

    /deep/ .el-input--small .el-input__inner {
      text-align: right;
    }

    .bulk-operation {
      .money-input {
        width: 108px;
        margin: 0 24px 0 6px;
      }

      .money {
        color: rgba(0, 0, 0, 0.6);
      }

      .cut-off-rule {
        margin: 17px 20px;
        background-color: rgba(0, 0, 0, 0.08);
        width: 1px;
        line-height: 60px;
        height: 26px;
      }
    }
  }

  .unpaid-list {
    display: flex;
    flex-wrap: wrap;
  }

  .box-list {
    flex-wrap: wrap;

    .el-icon-arrow-down {
      margin-left: 5px;
    }
    .item:hover {
      box-shadow: 1px 9px 20px 1px #ececec;
      border: 1px #ececec solid;
    }
    .item {
      border: 1px solid #ececec;
      width: 360px;
      margin-right: 32px;
      margin-bottom: 24px;
      background: #ffffff;
      border-radius: 4px;
      padding-bottom: 16px;
      position: relative;

      .title {
        line-height: 52px;
        padding: 0 16px;
        width: 100%;
        justify-content: space-between;
        background-image: url("../../../assets/picture/background-blue.png");
        background-size: 102%;
        background-repeat: no-repeat;
        border-radius: 4px 4px 0 0;

        .checkbox {
          margin-right: 6px;
        }

        .w50 {
          width: 50%;
        }
      }

      .title-img {
        line-height: 52px;
        padding: 0 16px;
        width: 100%;
        justify-content: space-between;
        background-image: url("../../../assets/picture/background-gray.png");
        background-size: 102%;
        background-repeat: no-repeat;
        border-radius: 4px 4px 0 0;

        .checkbox {
          margin-right: 6px;
        }

        .w50 {
          width: 50%;
        }
      }

      .list {
        padding: 12px 16px;

        .row {
          line-height: 24px;
        }
      }

      .btn {
        padding-left: 16px;
        height: 32px;

        /deep/ .el-input--small .el-input__inner {
          text-align: right;
        }

        .cut-off-rule {
          margin: 6px 16px;
          width: 1px;
          background-color: rgba(0, 0, 0, 0.08);
        }

        .padding-left {
          padding-left: 18px;
        }
      }
    }

    /*.item:nth-child(4n) {
                  margin-right: 0;
              }*/

    .closed-account-img {
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }

  .time-quantum {
    text-align: left;
    margin-bottom: 24px;
  }

  .bottom {
    text-align: left;
  }
}
.df unpaid-list.df > span:first-child button {
  background: #008cff;
}
.df unpaid-list.df > span:first-child button:hover {
  background: #409eff;
}
.e_account{
  div{
    text-align: left;
    margin-bottom: 10px;
    label{
      display: inline-block;
      width: 100px;
      text-align: right;
      margin-left:30px;
    }
  }
}
/*.all .unpaid-list{
      display: flex;
      flex-direction: row;
      justify-content: center;
  }*/
</style>